import { Component, OnInit, DoCheck, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Widget } from '../../../models/form';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';
@Component({
  selector: 'app-text-addable',
  templateUrl: './text-addable.component.html',
  styleUrls: ['./text-addable.component.scss']
})
export class TextAddableComponent {

  constructor(private fb: FormBuilder) { }
  @Input() widget: Widget;
  @Input() formGroup: FormGroup;
  @Input() align: "inline" | "break" = "inline";
  @Output() updateData = new EventEmitter();

  @Input() data = []

  public ownData = {
    "element0": null
  }



  private timeoutChange = null

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.data || this.data.length != 0) {
      for (let key in this.data) {
        this.ownData["element" + key] = this.data[key];
      }
    }
    this.initFormCtrl();
  }


  more() {
    this.ownData["element" + Object.keys(this.ownData).length] = null;
    this.initFormCtrl();
  }

  initFormCtrl() {
    let formG = {};
    for (let key in this.ownData) {
      if (key == "element0") {
        formG[key] = [this.ownData[key], Validators.required];
      }
      else {
        formG[key] = [this.ownData[key], null];
      }

    }
    this.formGroup = this.fb.group(formG);
    this.formGroup.valueChanges.subscribe(data => {
      let tab = [];
      for (let key in data) {
        if (data.hasOwnProperty(key) && data[key] != null) {
          tab.push(data[key]);
          this.ownData[key] = data[key];
        }
      }
      if (this.timeoutChange) {

        clearTimeout(this.timeoutChange);
        this.timeoutChange = null;
      }
      this.timeoutChange = setTimeout(() => {
        if (this.formGroup.status == "VALID") {
          this.timeoutChange = null;
          this.updateData.emit(tab);
        }
        else {
          this.updateData.emit(null);
        }

      }, 500)
    });
  }

  getDataKeys() {
    return Object.keys(this.ownData);
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form/text-addable/text-addable.component.ts